'use client';

import {getSections} from '@/components/sections/Dynamic.section';
import {useCommonComponentContext} from '@/context/ComponentContext';
import {useAccountStore} from '@/hooks';
import {getHygraphExtraProps} from '@/lib/utils/hygraph.utils';
import {PageHeroSectionFieldsFragment} from '@common/hygraph-schema';

type Fragments = PageHeroSectionFieldsFragment;

interface Props<T extends Fragments> {
	pageData: T;
}

export function HygraphPageProvider<T extends Fragments>({pageData}: Props<T>) {
	const {isLoading} = useAccountStore();
	const {LoadingComponent} = useCommonComponentContext();

	if (LoadingComponent && isLoading) {
		return <LoadingComponent />;
	}

	return <>{getSections(pageData?.refSections, getHygraphExtraProps)}</>;
}
